"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONCAT = exports.MERGE = exports.DELETE = exports.UPDATE = exports.UNSHIFT = exports.RESET = exports.PUSH = exports.SET = exports.handleAction = exports.createGetters = exports.createMutations = exports.mutations = exports.importModules = exports.createPaginaion = exports.createPagination = void 0;
const tslib_1 = require("tslib");
const get_1 = tslib_1.__importDefault(require("lodash/get"));
const set_1 = tslib_1.__importDefault(require("lodash/set"));
const camelCase_1 = tslib_1.__importDefault(require("lodash/camelCase"));
const isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
const isFunction_1 = tslib_1.__importDefault(require("lodash/isFunction"));
const isPlainObject_1 = tslib_1.__importDefault(require("lodash/isPlainObject"));
const isString_1 = tslib_1.__importDefault(require("lodash/isString"));
const createPagination = (config = {}) => {
    return Object.assign({ total: 0, currentPage: 1, perPage: 10, from: null, to: null, isLoaded: false, isLoading: false, isRefetching: false, data: [] }, config);
};
exports.createPagination = createPagination;
/**
 * @deprecated - Spelling mistake, use createPagination instead
 */
exports.createPaginaion = exports.createPagination;
/**
 * @example
 * importModules(
 *    require.context(
 *       "./modules", false, /\.store\.(js|ts)$/
 *    )
 * )
 *
 * @param context - Require context
 */
const importModules = (context) => {
    const modules = {};
    context.keys().forEach((filename) => {
        const moduleName = (0, camelCase_1.default)(filename.replace(/(\.\/|\.store\.(js|ts))/g, ''));
        modules[moduleName] = context(filename).default || context(filename);
    });
    return modules;
};
exports.importModules = importModules;
const SET = 'SET', PUSH = 'PUSH', RESET = 'RESET', UNSHIFT = 'UNSHIFT', UPDATE = 'UPDATE', DELETE = 'DELETE', MERGE = 'MERGE', CONCAT = 'CONCAT';
exports.SET = SET;
exports.PUSH = PUSH;
exports.RESET = RESET;
exports.UNSHIFT = UNSHIFT;
exports.UPDATE = UPDATE;
exports.DELETE = DELETE;
exports.MERGE = MERGE;
exports.CONCAT = CONCAT;
exports.mutations = {
    [SET]: (state, payload) => {
        if (!(0, isPlainObject_1.default)(payload)) {
            throw Error('Payload have to be an object');
        }
        Object.entries(payload).forEach(([path, value]) => {
            value = typeof value === 'function' ? value((0, get_1.default)(state, path)) : value;
            (0, set_1.default)(state, path, value);
        });
    },
    [RESET]: (state, initialState) => {
        exports.mutations.SET(state, initialState);
    },
    [PUSH]: (state, payload) => {
        if ((0, isArray_1.default)(payload)) {
            let [path, ...items] = payload;
            let target = (0, get_1.default)(state, path);
            if (!target || !(0, isArray_1.default)(target)) {
                throw Error('Specified state path not found or property is not an array');
            }
            target.push(...items);
        }
        else if ((0, isPlainObject_1.default)(payload)) {
            Object.entries(payload).forEach(([path, item]) => {
                let target = (0, get_1.default)(state, path);
                if (!target || !(0, isArray_1.default)(target)) {
                    throw Error('Specified state path not found or property is not an array');
                }
                let items = (0, isArray_1.default)(item) ? item : [item];
                target.push(...items);
            });
        }
        else
            throw Error('Invalid payload type.');
    },
    [UNSHIFT]: (state, payload) => {
        if ((0, isArray_1.default)(payload)) {
            let [path, ...items] = payload;
            let target = (0, get_1.default)(state, path);
            if (!target || !(0, isArray_1.default)(target)) {
                throw Error('Specified state path not found or property is not an array');
            }
            target.unshift(...items);
        }
        else if ((0, isPlainObject_1.default)(payload)) {
            Object.entries(payload).forEach(([path, item]) => {
                let target = (0, get_1.default)(state, path);
                if (!target || !(0, isArray_1.default)(target)) {
                    throw Error('Specified state path not found or property is not an array');
                }
                let items = (0, isArray_1.default)(item) ? item : [item];
                target.unshift(...items);
            });
        }
        else
            throw Error('Invalid payload type.');
    },
    [CONCAT]: (state, [path, items]) => {
        let target = (0, get_1.default)(state, path);
        if (!target || !(0, isArray_1.default)(target)) {
            throw Error('Specified state path not found or property is not an array');
        }
        (0, set_1.default)(state, path, target.concat(items));
    },
    [DELETE]: (state, [path, key, match = 'id']) => {
        let target = (0, get_1.default)(state, path);
        if (!target || !(0, isArray_1.default)(target)) {
            throw Error('Specified state path not found or property is not an array');
        }
        let keys = (0, isArray_1.default)(key) ? key : [key];
        (0, set_1.default)(state, path, (0, get_1.default)(state, path).filter((el) => !keys.includes(el[match])));
    },
    [UPDATE]: (state, [path, data, match = 'id']) => {
        let target = (0, get_1.default)(state, path);
        if (!target || !(0, isArray_1.default)(target)) {
            throw Error('Specified state path not found or property is not an array');
        }
        (0, set_1.default)(state, path, (0, get_1.default)(state, path).map((el) => {
            return (0, get_1.default)(el, match) === (0, get_1.default)(data, match) ? data : el;
        }));
    },
    [MERGE]: (state, [path, items, match = 'id', type = 'unshift']) => {
        let target = (0, get_1.default)(state, path);
        if (!target || !(0, isArray_1.default)(target)) {
            throw Error('Specified state path not found or property is not an array');
        }
        items.forEach((item) => {
            let index = target.findIndex((a) => (0, get_1.default)(a, match) === (0, get_1.default)(item, match));
            if (index !== -1)
                target.splice(index, 1, item);
            else {
                type === 'unshift' ? target.unshift(item) : target.push(item);
            }
        });
    },
};
const createMutations = (...types) => {
    if (!types.length)
        return Object.assign({}, exports.mutations);
    return Object.keys(exports.mutations)
        .filter((name) => types.includes(name))
        .reduce((m, a) => {
        return Object.assign(Object.assign({}, m), { [a]: exports.mutations[a] });
    }, {});
};
exports.createMutations = createMutations;
const createGetters = (...keys) => {
    return keys.reduce((getterTree, name) => {
        if ((0, isString_1.default)(name)) {
            getterTree[`$${name}`] = (state) => (0, get_1.default)(state, name);
        }
        if ((0, isPlainObject_1.default)(name)) {
            Object.entries(name).forEach(([key, path]) => {
                getterTree[`$${key}`] = (0, isString_1.default)(path)
                    ? (state) => (0, get_1.default)(state, path)
                    : path;
            });
        }
        return getterTree;
    }, {});
};
exports.createGetters = createGetters;
const handleAction = (apiRequestPromise, successCallback, errorCallback) => {
    return new Promise((resolve) => {
        apiRequestPromise.then(([error, response]) => {
            if (!error && (0, isFunction_1.default)(successCallback))
                successCallback(response);
            if (error && (0, isFunction_1.default)(errorCallback))
                errorCallback(error);
            resolve([error, response]);
        });
    });
};
exports.handleAction = handleAction;
